import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context";
import { t } from "../content";

export const ProductCard = ({ p, index = 0 }) => {
  const { lang } = useLang();
  return (
    <Link to={`/product/${p.id}`} data-testid={`product-card-${p.id}`} className="group block fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="img-zoom bg-[#F0EBE1] aspect-[3/4] relative">
        <img src={p.image} alt={p[`name_${lang}`]} className="w-full h-full object-contain" loading="lazy" />
        {p.is_unique && <span className="absolute top-3 left-3 bg-[#1A1A1A] text-[#F9F8F6] text-[10px] uppercase tracking-widest px-2 py-1">{t.product.unique[lang]}</span>}
        {p.is_new && !p.is_unique && <span className="absolute top-3 left-3 bg-[#F9F8F6] text-[#1A1A1A] text-[10px] uppercase tracking-widest px-2 py-1">{t.product.new[lang]}</span>}
      </div>
      <div className="pt-4">
        <h3 className="serif text-lg leading-tight">{p[`name_${lang}`]}{p.size ? ` - ${p.size}` : ""}</h3>
        <p className="text-sm text-[#737373] mt-1">{p.price.toFixed(2)} $ CAD</p>
      </div>
    </Link>
  );
};
